// spec/admin-ui/navigation.md: admin-ui-navigation-R19, R24, R25, R54.
import axios, { type AxiosError } from 'axios'
import { useAuthStore } from '@/stores/auth'
import { resolveApiBaseUrl } from '@/utils/api-base-url'

export const axiosInstance = axios.create({
  baseURL: resolveApiBaseUrl(), timeout: 30_000, withCredentials: true,
})
axiosInstance.interceptors.response.use((response) => response, (error: AxiosError<unknown>) => {
  const body = error.response?.data
  if (typeof body === 'object' && body !== null && 'error' in body && body.error === 'unauthenticated') {
    useAuthStore().endSession()
  }
  // The server owns token refresh. Never retry mutations or navigate away from unsaved input.
  return Promise.reject(error)
})
export default axiosInstance
